<template>
    <div class="HeroSelector">
        <div class="HeroSelector__selector">
            <div class="HeroSelector__input">
                <v-radio-group v-model="heroType"
                               row
                               @change="setFieldData"
                               dense
                               :label="label + ': '"
                >
                    <v-radio :label="choiceOne"
                             value="image"
                    ></v-radio>

                    <v-radio :label="choiceTwo"
                             value="color"
                    ></v-radio>
                </v-radio-group>
            </div>

            <div class="HeroSelector__help" v-if="helpText">
                <HelpModal v-if="helpText"
                           :text="helpText"
                           :title="helpTitle"
                ></HelpModal>
            </div>
        </div>
        <ImageSelector v-if="heroType === 'image'"
                       :field-id="fieldId"
                       :field-namespace="fieldNamespace"
                       :load-user-library="true"
                       :user-media="userMedia"
                       :load-stock-library="loadStock"
                       :stock-media="stockMedia"
                       :selected-image-id="''"
                       :field-location="section + '/' + card"
                       :allow-upload="true"
                       :upload-type="uploadType"
        />
    </div>
</template>

<script>

import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';
import store from '@/store/store';
import ImageSelector from '@/components/ImageSelector/ImageSelector';

export default {
    components: { ImageSelector },
    mixins: [SubmissionBoilerplate],

    computed: {
        stockMedia() {
            return store.state[this.fieldNamespace].stockMedia;
        },

        uploadType() {
            return store.state[this.fieldNamespace].options.uploadType;
        },

        userMedia() {
            return store.state[this.fieldNamespace].userMedia;
        },

        loadStock() {
            return store.state[this.fieldNamespace].options.loadStock;
        },

        card() {
            return store.state[this.fieldNamespace].card;
        },

        section() {
            return store.state[this.fieldNamespace].section;
        },

        label() {
            return store.state[this.fieldNamespace].options.heroSelector.label;
        },

        choiceOne() {
            return store.state[this.fieldNamespace].options.heroSelector.choiceOne;
        },

        choiceTwo() {
            return store.state[this.fieldNamespace].options.heroSelector.choiceTwo;
        },
    },

    data() {
        return {
            heroType: 'image',
        };
    },

    methods: {
        loadFieldData() {
            if (this.submission && this.submission.data) {
                this.heroType = this.submission.data.heroType;
            } else if (this.population && this.population.data) {
                this.heroType = this.population.data.heroType;
            } else if (this.submission && this.submission.selectedImage) {
                this.heroType = 'image';
            }

            this.setFieldData();
        },

        setFieldData()
        {
            if(this.heroType !== 'image') {
                this.fieldData = {
                    data: {
                        heroType: this.heroType,
                    },
                };
            }

            this.storeFieldData();
        },
    }
};
</script>
<style lang="scss">
.HeroSelector {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.HeroSelector__selector {
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    align-items: flex-start;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 14px;
}

.HeroSelector__input {
    flex: 0 0 90%;
    width: 90%;

    .v-input {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-input__slot {
        margin: 0 !important;
    }

    .v-input--radio-group__input {
        legend {
            font-weight: 500;
            flex: 0 0 100% !important;
            width: 100% !important;
            margin-bottom: 12px;

            @media (min-width: 600px) {
                flex: 0 0 auto !important;
                width: auto !important;
                margin-bottom: 0;
            }
        }
    }

    .v-messages {
        display: none !important;
    }
}

.HeroSelector__help {
    flex: 0 0 auto;
    width: auto;
    margin-top: -5px;
    margin-left: auto;

    @media (min-width: 600px) {
        margin-top: -3px;
    }
}

</style>
